import { AccountInfo } from '@azure/msal-browser';

export interface AppUser {
  id: string;
  username: string;
  email: string;
  name: string;
  role: string;
}

export function mapMsalAccountToAppUser(account: AccountInfo): AppUser {
  const email = account.username || '';
  const username = email.includes('@')
    ? email.split('@')[0].toLowerCase()
    : email.toLowerCase();

  return {
    id: account.localAccountId || account.homeAccountId,
    email,
    username,
    name: account.name || email || username,
    role: 'user',
  };
}
